import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userDetail } from "../../../store/actions/userActions";
import SurveyListHeader from "../../../component/layout/MainHeader";
import SurveyListSidebar from "../../../component/layout/MainSidebar";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import Svg from "../../../component/Svg";
import SearchInput from "../../../core/Inputs/SearchInput";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import { formatDate } from "./FormatDate";
import { formatTime } from "./FormatTime";
import { performHttpRequest } from "../../../../axios/PerformHttpRequest";
import style from "../../../views/style.module.css";
import Card from "../../../core/Card";
import debounce from 'lodash.debounce';

export default function RoiCalculation() {
  const { userData, userFlag } = useSelector((state) => state.userDataHeader);
  let permissions = {};
  if (userData && userData.length > 0) {
    try {
      permissions = JSON.parse(userData[0]?.module_permissions || "{}");
    } catch (error) {
      console.error("Error parsing module_permissions:", error);
    }
  }
  // Define permissions for the module
  const canAdd = permissions?.M1?.add === 1;
  const canEdit = permissions?.M1?.edit === 1;
  const canDelete = permissions?.M1?.del === 1;

  const apiUrl = process.env.REACT_APP_NODE_API_URL;
  const { id } = useParams();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  // Get the state props
  // Bradcums
  const location = useLocation();
  const breadcrumbs = location.state || JSON.parse(localStorage.getItem('custom-variable'));
  const getRoiCalculationDetail = async () => {
    try {
      console.log(`${apiUrl}/roi-calculated-fields/list/${id}`)
      const response = await performHttpRequest(
        "GET",
        `${apiUrl}/roi-calculated-fields/list/${id}`,
        ""
      );
      if (response.data?.statusCode === 200 && response.data?.result == 'success') {
        //console.log("roiId data ", response.data?.data)
        setData(response.data?.data);
      }
    } catch (error) {
      toast.error(error?.response?.data?.responseText);
    }
  };


  useEffect(() => {
    getRoiCalculationDetail();
  }, [id]);


  useEffect(() => {
    setFilteredData(data);
  }, [data]);


  const handleClosePopup = () => {
    setShowPopup(false); // Hide the popup
  };


  const handleEditTemplate = (row, breadcrumbs) => {
    console.log(breadcrumbs, row)
    let valueToFind = '/admin/roi';
    let keyFound = '';

    for (let key in breadcrumbs) {
      if (breadcrumbs[key] === valueToFind) {
        keyFound = key;
        break;
      }
    }
    const props = {
      [keyFound]: '/admin/roi',
      "Calculation & Logic": `/admin/roi/${id}/calculation-logic`,
      [row.roi_logic_name]: ``

    };
    // Save props to localStorage
    localStorage.setItem('custom-variable', JSON.stringify(props));
    const url = `/admin/roi/${id}/calculation-logic/add/${row.roi_calculated_field_id}`;
    window.open(url, '_blank');
  };



  const columns = [
    {
      width: "300px",
      name: "Logic name",
      sortable: true,
      sortField: "name",
      selector: (row) => row.roi_logic_name,
      cell: (row) => {
        const addDateTime = row?.add_date_time || ""; // Get the published field from the row
        return (
          <>
            <div className="w-100">
              <span className="surv-title">{row.roi_logic_name}</span>
              <div className="modified-text">
                Added Date Time {addDateTime}
              </div>
            </div>
          </>
        );
      },
    },

    {
      name: "Created by",
      selector: "added_by",
      sortable: true,
      sortField: "added_by",
      cell: (row) => {
        return (
          <>
            <div className="text-center w-100">
              <span className="created-text">{row?.name}</span>
            </div>
          </>
        );
      },
    },

    {
      name: "Status",
      selector: "status",
      sortable: true,
      sortField: "status",
      cell: (row) => {
        return (
          <>
            <div className="text-center w-100">
              {(row.is_active == 1) ? "Active" : "Inactive"}
            </div>
          </>
        );
      },
    },

    {
      name: "",
      width: "46px",
      cell: (row) => (
        <>
          {canEdit && (
            <div className="dropdown table-dropdown">
              <button
                className="btn dropdown-tgl"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <Svg name="action" />
              </button>
              <ul className="dropdown-menu dropdown-menu-end">
                {row?.status !== "publish" &&
                  <li>
                    <button
                      className="dropdown-item d-flex align-items-center"
                      type="button"
                      onClick={() => handleEditTemplate(row, breadcrumbs)}
                    >
                      <Svg name="dropdown-edit" />
                      <span className="dropdown-item ms-2">Edit</span>
                    </button>
                  </li>
                }
                {canDelete && (
                  <li>
                    <button
                      className="dropdown-item d-flex align-items-center" data-bs-toggle="modal" data-bs-target="#deletepage"
                      onClick={() => handleDeleteRoi(row)}
                      type="button"
                    >
                      <Svg name="dropdown-delete" />
                      <span className="dropdown-item ms-2">Delete</span>
                    </button>
                  </li>
                )}

              </ul>
            </div>
          )}
        </>
      ),
    },
  ];

  const handleClear = () => {
    setSearchQuery("")
    setFilteredData(data);
  }

  const handleSearch = debounce((inputValue) => {
    setSearchQuery(inputValue);
    if (inputValue.trim() != '') {
      const filteredList = data.filter(item =>
        item?.roi_logic_name.toLowerCase().includes(inputValue.toLowerCase())
      );
      setFilteredData(filteredList);
    }
  }, 300);


  const handleSelectedRowsChange = (rows) => {
    setSelectedRows(rows.selectedRows);
  };

  const conditionalRowStyles = [
    {
      when: (row) => selectedRows.some((r) => r.id === row.id),
      style: {
        backgroundColor: '#F5F5F5',
      },
    },
  ];

  const handleDeleteRoi = (row) => {
    setSelectedRow(row.roi_calculated_field_id);
  }

  const confirmDeleteButton = async () => {
    try {
      let data = {
        roi_calculated_field_id: selectedRow
      }
      const response = await performHttpRequest(
        "DELETE",
        `${apiUrl}/roi-calculated-fields/del`,
        data
      );

      if (response.data?.statusCode === 200) {
        toast.success(response?.data?.msg)
        getRoiCalculationDetail();
      } else {
        toast.error(response?.data?.msg)
      }
    } catch (error) {
      toast.error(error?.response?.data?.msg);
    }
  }

  return (
    <>
      <div className="d-flex flex-column main-outer-wrapper main-site-wrapper">
        <SurveyListHeader />
        <div id="viewport" className="d-flex">
          <SurveyListSidebar />
          <div className="flex-grow-1 d-flex">
            <div className="dashboard-page-outer flex-grow-1">
              <div className="custom-breadcrumb">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/admin/dashboard" className="home-item" title="Dashboard">Home</Link></li>
                    {Object.keys(breadcrumbs).slice(0, 2).map((key) => (
                      <li className="breadcrumb-item" key={key}><Link to={`${breadcrumbs[key]}`} >{key}</Link></li>
                    ))}
                    {/* <li className="breadcrumb-item" >ROI Calculator</li>
                  <li className="breadcrumb-item" >Calculator Name</li>
                  <li className="breadcrumb-item active" aria-current="page"><strong>Calculations</strong></li> */}
                  </ol>
                </nav>
              </div>
              <div className="dashboard-page-wrap">
                <div className="table-wrapper-view">
                  <div className="search-filter d-md-flex align-items-center surveyfilter">
                    <div className="flex-grow-1 pe-0 pe-md-3 mb-3 mb-md-0">
                      <SearchInput
                        className="custom-search-input"
                        type="def"
                        view="outlined"
                        color="primary"
                        placeholder="Search"
                        onSearch={handleSearch}
                        onClear={handleClear}
                        fill={true}
                      />
                    </div>
                    {canEdit && (
                      <Link
                        to={`/admin/roi/${id}/calculation-logic/add`}
                        className="btn btn-primary add-btn ms-md-2 mt-2 mt-md-0"
                      >
                        <Svg name="plus" /> Create
                      </Link>)}
                  </div>
                  <div className="tablePage bg-white">
                    <div className="content-table survey-table survey-table-height">
                      <div className="data-table-wrap custom-data-table first-check">
                        <DataTable
                          columns={columns}
                          data={filteredData}
                          selectableRows={true}
                          onSelectedRowsChange={handleSelectedRowsChange}
                          pagination
                          onRowSelected={(state) => handleSelectedRowsChange(state)}
                          selectableRowChecked={(row) => row.id === selectedRows[0]?.id}
                          conditionalRowStyles={conditionalRowStyles}
                        />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div className="customvar-modal modal custom-modal fade deleteModal" id="deletepage" tabIndex={-1} aria-labelledby="deleteModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body">
                  <div className={"formcontainer " + style.container}>
                    <div className={"formvawrapper delete-modal-wrap modal-sm " + style.wrapper}>
                      <Card view="raised" className={"formstyle p-0 " + style.card} >

                        <div className="delete-body-wrap delete-language">
                          <div className="heading">
                            <h3>Delete ROI Calculation</h3>
                            <p>Are you sure you want to delete ?</p>
                          </div>

                          <div className="button-wrap d-flex justify-content-end">
                            <button type="button" className="btn btn-bordered color-cancel" data-bs-dismiss="modal">Cancel</button>
                            <button type="button" className="btn btn-delete ms-3" onClick={confirmDeleteButton} data-bs-dismiss="modal">Confirm delete</button>
                          </div>
                        </div>
                      </Card>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
